import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ImpersonationBroker, ITemplateCard } from '../../viewmodels/AppViewModels';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export const MY_TEMPLATES_FILTER_KEY = 'myTemplateFilterKey';

export const useMyTemplatesFilter = ({
	impersonationContext,
	enabled = true,
	excludeExpired = true,
	industry,
	scopeFilter,
	sort = 'desc',
	sortBy = 'lastModifiedDate',
	term = '',
	templateType = Api.TemplateType.Email,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	excludeExpired?: boolean;
	industry: Api.Industry;
	scopeFilter?: Api.TemplateScopeFilter;
	sort?: 'asc' | 'desc';
	sortBy?: string;
	term?: string;
	templateType?: Api.TemplateType;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			const queryParams: any = {
				excludeExpired,
				sort,
				sortBy,
				templateType,
				search: term,
				scopeFilter,
			};

			return userSession.webServiceHelper.callAsync<ITemplateCard[]>(
				ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams,
					urlPath: `template/${encodeURIComponent(industry)}/me/filter`,
				}),
				'GET'
			);
		},
		queryKey: [MY_TEMPLATES_FILTER_KEY, templateType, excludeExpired, industry, sort, sortBy, scopeFilter, term],
	});
};

export const invalidateAllMyTemplatesFilter = () => {
	reactQueryClient.invalidateQueries({ queryKey: [MY_TEMPLATES_FILTER_KEY] });
};
